import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=07c46069&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c46069",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c46069')) {
      api.createRecord('07c46069', component.options)
    } else {
      api.reload('07c46069', component.options)
    }
    module.hot.accept("./TaskItem.vue?vue&type=template&id=07c46069&scoped=true", function () {
      api.rerender('07c46069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/activity/components/TaskItem.vue"
export default component.exports